import axios from "axios";
import { all, put, takeEvery, call, delay } from "redux-saga/effects";
import { getHeader,URL_RLB } from "../../../store/path";
import {savedSignupCompCreateData,
        savedSignupCompCreateDataByEmail,
        getOTPCallMainFetched,validatedPassword,checkedIfDataSaved,
        validatedOTP,finalDomainCreationStatus
      } from "./action";

function getInteceptorFunc(){
  const headerParam = getHeader();
  let self = this
  // console.log("headerParam=",headerParam)
  const instance = axios.create(headerParam);
  
  instance.interceptors.request.use(config => {
    // Object.keys(config.headers).forEach(key => {
    //   config.headers[key] = '********'; // replace the header value with asterisks
    // }); 
    // console.log("config=",config)
    // delete config.headers['X-RLB-SECRET-KEY'];
    // delete config.headers['X-RLB-SERVICE-KEY'];
    // delete config.headers['X-RLB-SERVICE-TIME'];
    return config;
  });
  return instance
}
      

/*CHECK IF ANY DATA SAVED AGINSTS THE EMAIL ID*/
function* getIdDataAlreadySavedMain() {
  yield takeEvery("CHECKINGIFDATASAVED", getIdDataAlreadySavedCall);
}

function* getIdDataAlreadySavedCall(action) {
  const {res} = yield call(getIdDataAlreadySavedCallAPI, action.payload);
  yield put(checkedIfDataSaved(res));
}

async function getIdDataAlreadySavedCallAPI(data) {
  let url = URL_RLB+"/login/check/login/details/"+data.data,
  instance = getInteceptorFunc();
  // console.log("data=",data,"===getHeader==",getHeader(),"=url=",url)
  try {
    const res = await instance
      .get(
        url,
        { crossDomain: true }
      )
    return ({ res });
  } catch (error) {
    return ({ error });
  }
}
/*CHECK IF ANY DATA SAVED AGINSTS THE EMAIL ID ENDS*/


/*VALIDATING PASSWORD*/
function* getPwValidatedMain() {
  yield takeEvery("VALIDATINGPASSWORD", getPwValidatedCall);
}

function* getPwValidatedCall(action) {
  const {res} = yield call(getPwValidatedCallAPI, action.payload);
  yield put(validatedPassword(res));
}

async function getPwValidatedCallAPI(data) {
  let url = URL_RLB+"/login/check/password",
    instance = getInteceptorFunc();
  // console.log("data=",data,"===getHeader==",getHeader(),"=url=",url)
  try {
    const res = await instance
      .post(
        url,
        data,
        { crossDomain: true }
      );
    return ({ res });
  } catch (error) {
    return ({ error });
  }
}
/*VALIDATING PASSWORD ENDS*/

/*VALIDATING OTP*/
function* getOTPValidatedMain() {
  yield takeEvery("VALIDATINGOTP", getOTPValidatedCall);
}

function* getOTPValidatedCall(action) {
  const {res} = yield call(getOTPValidatedCallAPI, action.payload);
  yield put(validatedOTP(res));
}

async function getOTPValidatedCallAPI(data) {
  let url = URL_RLB+"/login/check/otp",
    instance = getInteceptorFunc()
  console.log("data=",data,"===getHeader==",getHeader(),"=url=",url)
  try {
    const res = await instance
      .post(
        url,
        data,
        { crossDomain: true }
      );
    return ({ res });
  } catch (error) {
    return ({ error });
  }
}
/*VALIDATING OTP ENDS*/


/*GET SAVED JSON OBJECT  && SAVE THE DATA */
function* saveSignupCompCreate() {
  yield takeEvery("SAVE_SIGNUPCOMPCREATE_DATA", saveSignupCompCreateCall);
}
function* saveSignupCompCreateCall(action) {
  const {res} = yield call(saveSignupCompCreateAPI, action.payload);
  // console.log("res=",res)
  if(action.payload.curState == 1){
    yield put(savedSignupCompCreateDataByEmail(res));
  }else{
    res.data.data = action.payload.data
    res.data.curState = action.payload.curState
    yield put(savedSignupCompCreateData(res));
  }
}
async function saveSignupCompCreateAPI(data) {
  let url = data.curState == 1 ? URL_RLB+"/login/fetch/realbooks/"+data.data : URL_RLB+"/login/create",
      instance = getInteceptorFunc()
  // console.log("data=",data,"===getHeader==",getHeader(),"=url=",url)
  try {
    const res = data.curState == 1 ? await instance
      .get(
        url,
        { crossDomain: true }
      ):
     await instance
      .post(
        url,
        data.data,
        { crossDomain: true }
      );
    return ({ res });
  } catch (error) {
    return ({ error });
  }
}
/*GET SAVED JSON OBJECT  && SAVE THE DATA ENDS*/


/*GET OTP WITH EMAIL ID*/
function* getOTPCallMain() {
  yield takeEvery("FETCHOTPATMAILID", getOTPCall);
}

function* getOTPCall(action) {
  const {res} = yield call(getOTPCallAPI, action.payload);
  let otpSent  = false;
  if(res.data.type == "success"){
    otpSent = true;
  }
  yield put(getOTPCallMainFetched(otpSent));
}

async function getOTPCallAPI(data) {
  let url = URL_RLB+"/login/mail/sent/otp/"+data.data,
    instance = getInteceptorFunc()
  // console.log("data=",data,"===getHeader==",getHeader(),"=url=",url)
  try {
    const res = await instance
      .get(
        url,
        { crossDomain: true }
      )
    return ({ res });
  } catch (error) {
    return ({ error });
  }
}
/*GET OTP WITH EMAIL ID ENDS*/


/*FINAL DOMAIN CREATE AND USER CREATE FOR REALBOOKS LOGIN*/
function* getFinalDomainCreationMain() {
  yield takeEvery("FINALDOMAINCREATION", getFinalDomainCreationCall);
}

function* getFinalDomainCreationCall(action) {
  const {res} = yield call(getFinalDomainCreationCallAPI, action.payload);
  // console.log("res=",res)
  res.data.data = action.payload.data
  yield put(finalDomainCreationStatus(res));
  
}

async function getFinalDomainCreationCallAPI(data) {
  let url = URL_RLB+"/login/create/final/step",
    instance = getInteceptorFunc()
  // console.log("===getHeader==",getHeader(),"=url=",url,"=data=",data)
  // console.log("data.data=",data.data)
  try {
    const res = await instance
      .post(
        url,
        data.data,
        { crossDomain: true }
      );
    return ({ res });
  } catch (error) {
    return ({ error });
  }
}
/*FINAL DOMAIN CREATE AND USER CREATE FOR REALBOOKS LOGIN ENDS*/


export default function* signupCompCreateSaga() {
  yield all([saveSignupCompCreate(),getOTPCallMain(),
    getPwValidatedMain(),
    getFinalDomainCreationMain(),
    getIdDataAlreadySavedMain(),
    getOTPValidatedMain()
  ]);
}
